export const SOURCE_UPLOAD_URL = 'source-upload'
